import classNames from 'classnames';

import styles from './EcommerceInContentNotices.module.scss';

const EcommerceInContentNotices = (props: React.ComponentProps<'div'>) => {
    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <div {...props} className={classNames(props.className, styles.Content)}>
            {props.children}
        </div>
    );
};

export default EcommerceInContentNotices;
